import { motion } from 'framer-motion'

const FADE_IN_ANIMATION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.5, delay: 0.5 },
}

const FADE_IN_ANIMATION_ABOVE_THE_FOLD = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.2, delay: 0.1 },
}

const WHILE_IN_VIEW_ANIMATION = {
  opacity: 1,
  y: 0,
}

const VIEWPORT_ANIMATION = { once: true, amount: 0.2 }

const INITIAL_Y = -50
const INITIAL_OPACITY = 0

const DEFAULT_TRANSTION_EASE = 'easeOut'
const DEFAULT_DURATION = 0.8
const DEFAULT_DELAY = 0.2

type ScrollAnimationProps = {
  children: React.ReactNode
  initialOpacity?: number
  initialY?: number
  duration?: number
  delay?: number
  isFadeInAnimation?: boolean
  isFadeInAnimationAboveTheFold?: boolean
}

export const ScrollAnimation = ({
  children,
  initialOpacity = INITIAL_OPACITY,
  initialY = INITIAL_Y,
  duration = DEFAULT_DURATION,
  delay = DEFAULT_DELAY,
  isFadeInAnimation = false,
  isFadeInAnimationAboveTheFold = false,
}: ScrollAnimationProps) => {
  if (isFadeInAnimation) {
    return <motion.div {...FADE_IN_ANIMATION}>{children}</motion.div>
  }

  if (isFadeInAnimationAboveTheFold) {
    return (
      <motion.div {...FADE_IN_ANIMATION_ABOVE_THE_FOLD}>{children}</motion.div>
    )
  }

  return (
    <motion.div
      whileInView={WHILE_IN_VIEW_ANIMATION}
      viewport={VIEWPORT_ANIMATION}
      initial={{ opacity: initialOpacity, y: initialY }}
      transition={{
        ease: DEFAULT_TRANSTION_EASE,
        duration,
        delay,
      }}
    >
      {children}
    </motion.div>
  )
}
